export enum QueryKey {
  getAffiliationProgram = 'getAffiliationProgram',
}
